<!-- 奖励规则说明 -->
<template>
  <div>
    <vanPopup v-model="show" class="padding-20">
      <div class="main">
        <div class="title">推广合伙人服务费税费规则</div>
        <div class="center">
        1. 光子易向您展示的服务费结算价格及实际支付的服务费均为税后金额。光子易向您支付的服务费中已预扣预缴了您因提供本服务所得应缴纳的个人所得税。若因您有其他非本服务收入导致办理个人所得税年度汇算清缴时涉及补税的，需补税款由您自行承担。如涉及个人所得税以外的税费，您应自行缴纳。<br/><br/>

        2. 如您使用同一身份证号认证多个光子易推广合伙人账号的，光子易会汇总税前总收入计算扣税。
        </div>
        <div class="btn" @click="close">确定</div>
      </div>
    </vanPopup>
  </div>
</template>

<script>
export default {
  name: 'rewardRulesModal',
  data() {
    return {
      show: false
    }
  },
  methods: {
    openShow() {
      this.show = true
    },
    // 关闭窗口
    close() {
      this.show = false
    }
  }
}
</script>
<style lang="less" scoped>
/deep/.main {
  width: 343px;
  display: flex;
  flex-direction: column;
  background: #282830;
  padding-bottom: 28px;
  border-radius: 12px;
  height: calc(100vh - 160px);
  box-sizing: border-box;
  color: rgba(255,255,255,0.86);
  .title {
    font-size: 22px;
    font-weight: 800;
    line-height: 33px;
    height: 33px;
    text-align: center;
    padding-top: 36px;
    padding-bottom: 24px;
  }
  .center {
    overflow: auto;
    padding: 0 20px;
    margin-bottom: 5px;
    font-size: 13px;
    flex: 1;
    font-weight: 500;
    line-height:22px;
    .point {
      display: flex;
      &::before {
        content: '';
        width: 8px;
        flex-shrink: 0;
        height: 8px;
        top: 5px;
        position: relative;
        background-color: rgba(18, 57, 160, 1);
        margin-right: 8px;
        border-radius: 50%;
      }
    }
  }
  .btn {
    width: 223px;
    height: 50px;
    background: #ffdd3f;
    border-radius: 25px;
    font-weight: 600;
    font-size: 15px;
    color: #121212;
    line-height: 50px;
    height: 50px;
    text-align: center;
    margin: 0 auto;
    margin-top: 20px;
  }
}
/deep/.van-popup {
  background-color: transparent;
  top: 44%;
}
.padding-20 {
  padding: 20px 0;
}
// 兼容iphone xr  xrmax
  @media screen and (width: 414px) and (height: 808px){
    .main {
      height: calc(100vh - 98px);
    }
    /deep/.van-popup--center{
      top: 47%;
    }
  }
</style>
